import {connect} from '../../../../redux/utils'
import {bindActionCreators} from 'redux'
import {
    getCustomers,
    getProjects,
    getTasks,
    getCanManageCustomerIds,
    getCanWorkCustomerIds,
    getCanManageProjectIds,
    getCanWorkProjectIds,
    getCanManageTaskIds,
    getCanWorkTaskIds,
    getSelectedCustomer,
    getSelectedProject,
    getProjectCountsByCustomers,
    getTaskCountsByCustomers,
    getTaskCountsByProjects,
    isLoading,
    getChangingCustomerAssignments,
    getChangingProjectAssignments,
    getChangingTaskAssignments,
    getEditingUser,
    areAllCustomersAssigned,
    areAllProjectsAssigned,
    areAllTasksAssigned,
    areSomeCustomersOrLowerAssigned,
    areSomeProjectsOrLowerAssigned,
    areSomeTasksAssigned,
    areFutureCustomersAssigned,
    areFutureProjectsAssigned,
    areFutureTasksAssigned,
    showOnlyActiveEntities,
    getCustomersSearchText,
    getCustomersSearchOpen,
    getProjectsSearchText,
    getProjectsSearchOpen,
    getTasksSearchText,
    getTasksSearchOpen,
    getViewerCanManageCustomerIds,
    getViewerCanManageProjectIds,
    getCanManageCustomerExcludeSelfIds,
    getCanManageProjectExcludeSelfIds,
    canManageParentCustomer,
    canManageParentProject,
} from '../selectors'
import {
    changeCustomerAssignment,
    changeProjectAssignment,
    changeTaskAssignment,
    deselectCustomer,
    deselectProject,
    selectCustomer,
    selectProject,
    loadMoreEntities,
    changeOnlyActive,
    changeCustomersSearchText,
    clearCustomersSearchText,
    changeProjectsSearchText,
    clearProjectsSearchText,
    changeTasksSearchText,
    clearTasksSearchText,
    closeEditor,
    changeAllCustomersAssignments,
    changeAllProjectsAssignments,
    changeAllTasksAssignments,
    changeAllExistingAndFutureProjectsAssignment,
    changeAllExistingAndFutureTasksAssignment,
} from '../actions'
import {ManagementAssignmentsEditor} from '../../managementAssignmentsEditor/components/ManagementAssignmentsEditor'

export default connect(
    state => ({
        viewerCanManageCustomerIds: getViewerCanManageCustomerIds(state),
        viewerCanManageProjectIds: getViewerCanManageProjectIds(state),
        user: getEditingUser(state),
        customers: getCustomers(state),
        projects: getProjects(state),
        tasks: getTasks(state),
        futureCustomersAssigned: areFutureCustomersAssigned(state),
        futureProjectsAssigned: areFutureProjectsAssigned(state),
        futureTasksAssigned: areFutureTasksAssigned(state),
        someCustomersOrLowerAssigned: areSomeCustomersOrLowerAssigned(state),
        someProjectsOrLowerAssigned: areSomeProjectsOrLowerAssigned(state),
        someTasksAssigned: areSomeTasksAssigned(state),
        allCustomersAssigned: areAllCustomersAssigned(state),
        allProjectsAssigned: areAllProjectsAssigned(state),
        allTasksAssigned: areAllTasksAssigned(state),
        canWorkCustomerIds: getCanWorkCustomerIds(state),
        canManageCustomerIds: getCanManageCustomerIds(state),
        canManageCustomerExcludeSelfIds: getCanManageCustomerExcludeSelfIds(state),
        canWorkProjectIds: getCanWorkProjectIds(state),
        canManageProjectIds: getCanManageProjectIds(state),
        canManageProjectExcludeSelfIds: getCanManageProjectExcludeSelfIds(state),
        canWorkTaskIds: getCanWorkTaskIds(state),
        canManageTaskIds: getCanManageTaskIds(state),
        projectCountsByCustomers: getProjectCountsByCustomers(state),
        taskCountsByCustomers: getTaskCountsByCustomers(state),
        taskCountsByProjects: getTaskCountsByProjects(state),
        selectedCustomer: getSelectedCustomer(state),
        selectedProject: getSelectedProject(state),
        loading: isLoading(state),
        changingCustomerAssignments: getChangingCustomerAssignments(state),
        changingProjectAssignments: getChangingProjectAssignments(state),
        changingTaskAssignments: getChangingTaskAssignments(state),
        onlyActive: showOnlyActiveEntities(state),
        customersSearchOpen: getCustomersSearchOpen(state),
        customersSearchText: getCustomersSearchText(state),
        projectsSearchOpen: getProjectsSearchOpen(state),
        projectsSearchText: getProjectsSearchText(state),
        tasksSearchOpen: getTasksSearchOpen(state),
        tasksSearchText: getTasksSearchText(state),
        canManageParentCustomer: canManageParentCustomer(state),
        canManageParentProject: canManageParentProject(state),
    }),
    dispatch => bindActionCreators({
        changeCustomerAssignment,
        changeProjectAssignment,
        changeTaskAssignment,
        changeAllCustomersAssignments,
        changeAllProjectsAssignments,
        changeAllTasksAssignments,
        deselectCustomer,
        deselectProject,
        selectCustomer,
        selectProject,
        loadMoreEntities,
        changeOnlyActive,
        changeCustomersSearchText,
        clearCustomersSearchText,
        changeProjectsSearchText,
        clearProjectsSearchText,
        changeTasksSearchText,
        clearTasksSearchText,
        closeEditor,
        changeAllExistingAndFutureProjectsAssignment,
        changeAllExistingAndFutureTasksAssignment,
    }, dispatch)
)(ManagementAssignmentsEditor)


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/createUserManagementAssignmentsEditor/components/CreateUserManagementAssignmentsEditor.js